import angular from 'angular';
import { StepTypeName } from './flowingly.constants';
import ActivityTaskType from '@Shared.Angular/@types/core/contracts/queryModel/workflow/steps/activityTaskType';

angular
  .module('flowingly.services')
  .factory('flowinglyActivityService', flowinglyActivityService);

flowinglyActivityService.$inject = ['BPMN_CONSTANTS', 'flowinglyConstants'];

function flowinglyActivityService(BPMN_CONSTANTS, flowinglyConstants) {
  //API
  const service = {
    isActivity: isActivity,
    isComponent: isComponent,
    isTaskActivity: isTaskActivity,
    isApprovalActivity: isApprovalActivity,
    isMultipleApprovalActivity: isMultipleApprovalActivity,
    isTaskOrSingleApprovalActivity: isTaskOrSingleApprovalActivity,
    findStepTypeNumberWithName: findStepTypeNumberWithName
  };

  return service;

  //////////// Public API Methods
  function isActivity(modelNode) {
    return modelNode && modelNode.category === BPMN_CONSTANTS.ACTIVITY;
  }

  function isComponent(modelNode) {
    return (
      modelNode &&
      modelNode.category === flowinglyConstants.nodeCategory.COMPONENT
    );
  }

  function isTaskActivity(modelNode) {
    return modelNode && modelNode.taskType === ActivityTaskType.TASK;
  }

  function isTaskOrSingleApprovalActivity(modelNode) {
    return (
      modelNode &&
      (modelNode.taskType === ActivityTaskType.TASK ||
        modelNode.taskType === ActivityTaskType.APPROVAL)
    );
  }

  function isApprovalActivity(modelNode) {
    return (
      modelNode &&
      (modelNode.taskType === ActivityTaskType.APPROVAL ||
        modelNode.taskType === ActivityTaskType.PARALLEL_APPROVAL ||
        modelNode.taskType === ActivityTaskType.SEQUENTIAL_APPROVAL)
    );
  }

  function isMultipleApprovalActivity(modelNode) {
    return (
      modelNode &&
      (modelNode.taskType === ActivityTaskType.PARALLEL_APPROVAL ||
        modelNode.taskType === ActivityTaskType.SEQUENTIAL_APPROVAL)
    );
  }

  function findStepTypeNumberWithKey(value: string) {
    for (const key in ActivityTaskType) {
      if (key === value) {
        return ActivityTaskType[key];
      }
    }
    return undefined;
  }

  function findStepTypeNumberWithName(value: string) {
    for (const key in StepTypeName) {
      if (StepTypeName[key] === value) {
        return findStepTypeNumberWithKey(key);
      }
    }
    return undefined;
  }
}

export type FlowinglyActivityServiceType = ReturnType<
  typeof flowinglyActivityService
>;
